import React from 'react';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';
import ANALYTICS_CONFIG from '../../../config/analytics.config';// import { logger } from "../../utils/logger";
interface GoogleAnalyticsProps {
  measurementId?: string;
  debugMode?: boolean;
}

// Global types are declared in src/renderer/types/global.d.ts

/**
 * Google Analytics Component
 * 
 * Initializes GA4 tracking and integrates with React Router for SPA page view tracking.
 * Uses centralized configuration from analytics.config.ts.
 */
const GoogleAnalytics: React.FC<GoogleAnalyticsProps> = ({ 
  measurementId = ANALYTICS_CONFIG.measurementId,
  debugMode = ANALYTICS_CONFIG.debugMode 
}) => {
  // Use the custom hook for React Router integration
  useGoogleAnalytics({ measurementId, debugMode });

  return null; // This component doesn't render anything
};

export default GoogleAnalytics; 
